// src/services/endpoints/authEndpoints.js

import { AUTH_ENDPOINTS, ENDPOINTS } from "../config/apiconfig";
import { apiSlice } from "../apiSlice";
import { setStatusLoading } from "../../redux/featuresSlice/commonSlice";

export const authEndpoints = (builder) => ({
  login: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.LOGIN,
      method: "POST",
      data: credentials,
    }),
    async onQueryStarted(arg, { queryFulfilled }) {
      try {
        const { data } = await queryFulfilled;
        localStorage.setItem("token", data.token);
      } catch (error) {
        // console.error("Login error:", error);
      }
    },
  }),

  signup: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.REGISTER,
      method: "POST",
      data: credentials,
    }),
    async onQueryStarted(arg, { queryFulfilled }) {
      try {
        const { data } = await queryFulfilled;
        localStorage.setItem("token", data.token);
      } catch (error) {
        // console.error("Signup error:", error);
      }
    },
  }),

  verifyOTP: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.VERIFYOTP,
      method: "POST",
      data: credentials,
    }),
    async onQueryStarted(arg, { queryFulfilled }) {
      try {
        const { data } = await queryFulfilled;
        localStorage.setItem("token", data.token);
      } catch (error) {
        // console.error("Signup error:", error);
      }
    },
  }),

  verifyOTPSignUp: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.VERIFY_OTP_SIGUP,
      method: "POST",
      data: credentials,
    }),
    async onQueryStarted(arg, { queryFulfilled }) {
      try {
        const { data } = await queryFulfilled;
        localStorage.setItem("token", data.token);
      } catch (error) {
        // console.error("Signup error:", error);
      }
    },
  }),

  resendOTPSignUp: builder.mutation({
    query: (credentials) => ({
      url: AUTH_ENDPOINTS.RESEND_OTP_SIGN_UP,
      method: "POST",
      data: credentials,
    }),
    async onQueryStarted(arg, { queryFulfilled }) {
      try {
        const { data } = await queryFulfilled;
        localStorage.setItem("token", data.token);
      } catch (error) {
        // console.error("Signup error:", error);
      }
    },
  }),

  logout: builder.mutation({
    query: () => ({
      url: AUTH_ENDPOINTS.LOGOUT,
      method: "POST",
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        await queryFulfilled;
        localStorage.removeItem("token");
        dispatch(apiSlice.util.resetApiState());
      } catch (error) {
        // console.error("Logout error:", error);
      }
    },
  }),

  getQuestDetailsPublic: builder.query({
    query: ({ quest_id }) => ({
      url: `${ENDPOINTS.GET_QUEST_DETAILS_PUBLIC}/${quest_id}`,
      method: "GET",
      providesTags: (result, error, { quest_id }) => [
        { type: "QuestDetails", id: `Detail_${quest_id}` },
      ],
    }),
    async onQueryStarted(arg, { dispatch, queryFulfilled }) {
      try {
        dispatch(setStatusLoading(true));
        await queryFulfilled;
      } catch (error) {
        // if (error.error.status === 422) {
        //   toast.error(error.error.data.detail[0].msg);
        //   setTimeout(() => {
        //     window.location.href = "/quest";
        //   }, 1000);
        // }
        console.error("Error fetching quest list:", error);
      } finally {
        dispatch(setStatusLoading(false));
      }
    },
  }),

  getQuestListPerLocation: builder.query({
    query: ({
      order = "DESC",
      page = 1,
      limit = 10,
      status,
      search,
      id_location,
    }) => ({
      url: `${ENDPOINTS.QUEST_PER_LOCATION_LIST}`,
      method: "GET",
      params: { order, page, limit, status, search, id_location },
    }),
  }),
});
